"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppMediaProvider = exports["default"] = exports.DeviceTypes = void 0;
var _device = _interopRequireDefault(require("baseStyles/enums/device"));
var _useTopWindowSize = require("hooks/useTopWindowSize");
var _react = _interopRequireWildcard(require("react"));
var _reactResponsive = require("react-responsive");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DeviceTypes = exports.DeviceTypes = _device["default"].types;
;
var AppMediaProviderContext = /*#__PURE__*/_react["default"].createContext({});
var AppMediaProvider = function AppMediaProvider(_ref) {
  var children = _ref.children;
  var windowSize = (0, _useTopWindowSize.useTopWindowSize)();
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    minWidth: _device["default"].breakpoints[_device["default"].types.Desktop].min
  }, windowSize);
  var isTablet = (0, _reactResponsive.useMediaQuery)({
    minWidth: _device["default"].breakpoints[_device["default"].types.Tablet].min,
    maxWidth: _device["default"].breakpoints[_device["default"].types.Tablet].max
  }, windowSize);
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _device["default"].breakpoints[_device["default"].types.Mobile].max
  }, windowSize);
  var isMobileSmall = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _device["default"].breakpoints[_device["default"].types.MobileSmall].max
  }, windowSize);
  var isMobileSmallLandscape = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _device["default"].breakpoints[_device["default"].types.MobileSmall].max,
    orientation: "landscape"
  }, windowSize);
  var isMobileLandscape = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _device["default"].breakpoints[_device["default"].types.Mobile].max,
    orientation: "landscape"
  }, windowSize);
  var currentDevice = (0, _react.useMemo)(function () {
    if (isDesktop) return _device["default"].types.Desktop;else if (isTablet) return _device["default"].types.Tablet;else if (isMobile) return _device["default"].types.Mobile;else if (isMobileLandscape) return _device["default"].types.MobileLandscape;
  }, [isDesktop, isTablet, isMobile, isMobileLandscape]);
  var values = {
    isDesktop: isDesktop,
    isTablet: isTablet,
    isMobile: isMobile,
    isMobileSmall: isMobileSmall,
    isMobileLandscape: isMobileLandscape,
    isMobileSmallLandscape: isMobileSmallLandscape,
    currentDevice: currentDevice
  };
  return /*#__PURE__*/_react["default"].createElement(AppMediaProviderContext.Provider, {
    value: values,
    "data-sentry-element": "unknown",
    "data-sentry-component": "AppMediaProvider",
    "data-sentry-source-file": "AppMediaProvider.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-width": windowSize.width,
    "data-height": windowSize.height,
    className: "media-device-".concat(currentDevice)
  }, children));
};
var _useAppMediaProvider = exports.useAppMediaProvider = function useAppMediaProvider() {
  var context = (0, _react.useContext)(AppMediaProviderContext);
  if (!context) {
    // throw Error(`Use ${useAppMediaProvider.name} in ${AppMediaProviderContext.displayName}`);
    console.warn("Use ".concat(_useAppMediaProvider.name, " in ").concat(AppMediaProviderContext.displayName));
  }
  return context;
};
var _default = exports["default"] = AppMediaProvider;